import React, { useCallback, useEffect, useRef, useState } from "react";
import '../invoice.css';
import PaymentOutInvoicePage from "./PaymentOutInvoicePage";
import { Link } from "react-router-dom";

const PrintBtnPaymentOutPdf = ({auth, loading}) => {
    const pdfRef = useRef(null);
    const [timeLeft, setTimeLeft] = useState(5); 
    const [isActive, setIsActive] = useState(false);
    const [isClickToPrint, setIsClickToPrint] = useState(false);
    
    const triggerPrint = useCallback(() => {
        console.log("Print triggered!");
        setIsClickToPrint(true);
    }, []);
    
    useEffect(() => {
        let timer = null;
    
        if (isActive && timeLeft > 0) {
          timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
          }, 1000);
        } else if (timeLeft === 0) {
          triggerPrint(); 
          timer = setTimeout(() => {
            setIsActive(false);
            loading(false);
            clearInterval(timer);
          }, 1000); 
        }
    
        return () => clearInterval(timer);
      }, [isActive, timeLeft, triggerPrint]);

   
      const startCountdown = () => {
        loading(true);
        setTimeLeft(5); 
        setIsActive(true);
        setIsClickToPrint(false); 
      };

     
    
   
    return (
        <>
            {
                isActive && <PaymentOutInvoicePage pdfRef={pdfRef} auth={auth} isClickToPrint={isClickToPrint} />
            }
            <Link className="dropdown-item" style={{ textTransform: 'capitalize' }} onClick={() => {
                startCountdown();
            }}>
                Print
            </Link>
        </>
    )
}
export default PrintBtnPaymentOutPdf;